<w-block-ui [blocked]="blocked" [title]="'processing' | translate" [text]="'please_wait' | translate"></w-block-ui>

<form [formGroup]="requestForm" (ngSubmit)="onSubmit()">
  <w-page-header [title]="'registration.pageTitle' | translate" [disableUppercase]="true" [showPortfolio]="false">
  </w-page-header>
  <w-step>
    <p facet-step-info [innerHTML]="'registration.description' | translate "></p>
  </w-step>

  <w-edit-panel>
    <w-section>
      <w-slot>
        <w-input-text [label]="'registration.FIRST_NAME' | translate" [labelOnTop]="true" [required]="true"
          formControlName="firstname">
          @if (submitted && f.firstname.errors?.required) {
            <f-facet name="error">{{'validationWarning' | translate }}</f-facet>
          }
          @if (submitted && f.firstname.errors?.maxlength) {
            <f-facet name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-input-text [label]="'registration.LAST_NAME' | translate" [labelOnTop]="true" [required]="true"
          formControlName="lastname">
          @if (submitted && f.lastname.errors?.required) {
            <f-facet name="error">{{'validationWarning' | translate }}</f-facet>
          }
          @if (submitted && f.lastname.errors?.maxlength) {
            <f-facet name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>
        <w-input-text [label]="'registration.JOB_TITLE' | translate" [labelOnTop]="true" [required]="true"
          formControlName="jobtitle">
          @if (submitted && f.jobtitle.errors?.required) {
            <f-facet name="error">{{'validationWarning' | translate }}</f-facet>
          }
          @if (submitted && f.jobtitle.errors?.maxlength) {
            <f-facet name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>

        <w-input-text [label]="'registration.ORGANIZATION' | translate" [labelOnTop]="true" [required]="true"
          formControlName="organization">
          @if (submitted && f.organization.errors?.required) {
            <f-facet name="error">{{'validationWarning' | translate
            }}</f-facet>
          }
          @if (submitted && f.organization.errors?.maxlength) {
            <f-facet name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
          }
        </w-input-text>

        <!-- <w-input-text
        [label]="'registration.DATE_OF_BIRTH' | translate"
        [labelOnTop]="true"
        [required]="true"
        formControlName="dateofbirth"
        >
        <f-facet name="error" *ngIf="submitted && f.dateofbirth.errors">{{'validationWarning' | translate }}</f-facet>
      </w-input-text> -->

      <w-input-date [label]="'registration.DATE_OF_BIRTH' | translate" [labelOnTop]="true" [required]="true"
        formControlName="dateofbirth" dateFormat="dd/mm/yy" [language]="currentLanguage" >
        @if (submitted && f.dateofbirth.errors) {
          <f-facet name="error">{{'validationWarning' | translate }}</f-facet>
        }
      </w-input-date>

      <w-input-text [label]="'registration.CITY' | translate" [labelOnTop]="true" [required]="true"
        formControlName="city">
        @if (submitted && f.city.errors?.required) {
          <f-facet name="error">{{'validationWarning' | translate }}</f-facet>
        }
        @if (submitted && f.city.errors?.maxlength) {
          <f-facet name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
        }
      </w-input-text>

      <w-select-one [label]="'registration.COUNTRY' | translate" [labelOnTop]="true" [required]="true"
        formControlName="country" [options]="countryOptions">
        @if (submitted && f.country.errors) {
          <f-facet name="error">{{'validationWarning' | translate }}</f-facet>
        }
      </w-select-one>

      <w-input-text [label]="'registration.EMAIL' | translate" [labelOnTop]="true" [required]="true"
        formControlName="emailc" [type]="'email'">
        @if (submitted && f.emailc.errors?.required) {
          <f-facet name="error">{{'validationWarning' | translate
          }}</f-facet>
        }
        @if (f.emailc.errors?.email) {
          <f-facet name="error">{{'validationEmail' | translate }}</f-facet>
        }
        @if (submitted && f.emailc.errors?.maxlength) {
          <f-facet name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
        }
      </w-input-text>
    </w-slot>
  </w-section>


  <w-section>
    <w-slot>
      <w-input-text [label]="'registration.ONLINE_PROFILE' | translate" [labelOnTop]="true"
        formControlName="onlineprofile">
        @if (submitted && f.onlineprofile.errors?.maxlength) {
          <f-facet name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
        }
      </w-input-text>
    </w-slot>
  </w-section>

  <w-section>
    <f-facet name="header">{{'registration.ATTACH_PROFLE' | translate }}</f-facet>
    <w-slot>
            <w-input-file [isLarge]="false" [auto]="false" [multiple]="true" [sizeLimit]="10000000"
              [labelSelect]="'registration.ADD_DOCUMENT' | translate"
              [invalidFileSizeMessageSummary]="'ValidFileSize' | translate" invalidFileSizeMessageDetail="" [showUploadButton]="false" [auto]="false"
              (wSelected)="onFileChange($event)" formControlName="documents">
        @if (isTotalSizeExceeded) {
          <f-facet name="error">{{'common.maxUploadAttachment' | translate}}</f-facet>
        }
      </w-input-file>
    </w-slot>
  </w-section>

  <w-section>
    <w-slot>
      <w-input-textarea [label]="'registration.ABOUT_WIPO' | translate" [placeholder]="''" formControlName="how">
        @if (submitted && f.how.errors?.maxlength) {
          <f-facet name="error">{{'textLengthWarning' | translate: { maxLength: 255 } }</f-facet>
        }
      </w-input-textarea>
    </w-slot>
  </w-section>

  <!--<w-section>
  <w-slot>
    <w-input-text
      label="Verification"
      [labelOnTop]="true"
      [required]="true"
      formControlName="verification"
      >
      <f-facet name="error" *ngIf="submitted && f.verification.errors">This field cannot be empty</f-facet>
    </w-input-text>
  </w-slot>
</w-section>-->

</w-edit-panel>

</form>

<f-facet name="step-info">
  <w-page-header [disableUppercase]="true" [showPortfolio]="false">
    <f-facet name="actions">
      <button w-button [isDefault]="true" [isSecondary]="false" [disabled]="false" [buttonType]="'text'"
        type="submit" (click)="onSubmit()">
        {{ 'submitRequest' | translate }}
      </button>
    </f-facet>
  </w-page-header>
  <br><br>
</f-facet>

@if (isOpen) {
  <w-dialog [style]="style">
    <w-step [title]="'registration.alerTitle' | translate" [reviewMode]="true">
      <div facet-step-info [innerHTML]="'registration.alerText' | translate"></div>
      <button w-button (click)="closeDialogbox()" facet-step-actions>OK</button>
    </w-step>
  </w-dialog>
}